// Front-end configuration. Plain constants, read at build time.

// Home page layout. 'panel' is the results panel beside a sticky map;
// 'current' is the page as it was before (map above, infinite-scroll grid).
export const HOME_LAYOUT = 'panel'

// Show the Current / Panel switcher on the home page. Off in production: the
// layout above applies and neither ?layout= nor a stored choice overrides it.
export const SHOW_LAYOUT_CONTROLS = false
